import * as tslib_1 from "tslib";
import React from 'react';
import isString from 'lodash/isString';
import { withRipple } from '@sinoui/ripple';
import isSinouiElement from '../utils/reactHelpers';
import { SimpleIcon } from '../Icon';
import styled, { withProps } from '../styles';
import style from './style';
var StyledButton = withProps()(styled.button.attrs({
    className: 'sinoui-button',
}))(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), style);
var ButtonInner = function (props) {
    var handleChildren = function () {
        return React.Children.map(props.children, 
        // tslint:disable-next-line:no-any
        function (child) {
            if (isString(child)) {
                return React.createElement("span", { className: "sinoui-button-title" }, child);
            }
            else if (isSinouiElement(child, ['Icon'])) {
                return React.createElement(SimpleIcon, tslib_1.__assign({}, child.props));
            }
            else {
                return child;
            }
        });
    };
    var children = props.children, rest = tslib_1.__rest(props, ["children"]);
    var Comp = props.comp || StyledButton;
    return React.createElement(Comp, tslib_1.__assign({}, rest), handleChildren());
};
ButtonInner.defaultProps = {
    type: 'button',
    color: 'primary',
};
var Button = withRipple()(ButtonInner);
Button.displayName = 'Button';
Button.sinouiName = 'Button';
export default Button;
var templateObject_1;
//# sourceMappingURL=Button.js.map